var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiArrowUpCircleFill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3106_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.267 3.10938C20.707 3.10938 25.9337 8.33604 25.9337 14.776C25.9337 21.216 20.707 26.4427 14.267 26.4427C7.82701 26.4427 2.60034 21.216 2.60034 14.776C2.60034 8.33604 7.82701 3.10938 14.267 3.10938ZM15.4337 14.776H18.9337L14.267 10.1094L9.60034 14.776H13.1003V19.4427H15.4337V14.776Z",
    fill: "#8080FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3106_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.26709 0.773438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiArrowUpCircleFill);
export default __webpack_public_path__ + "static/media/ri-arrow-up-circle-fill.711548c20a4553683793e4307d9a0f9e.svg";
export { ForwardRef as ReactComponent };